// extracted by mini-css-extract-plugin
export default {"container":"SearchInput2_container__hrsCh","input":"SearchInput2_input__HOnG9","iconButton":"SearchInput2_iconButton__GwTFn","clearButton":"SearchInput2_clearButton__x6wO6"};